export const swedishVoices = (voices) => voices.filter((voice) => /^sv(?:[-_]|$)/i.test(voice.lang));

export function selectSwedishVoice(voices, preferredURI) {
  const available = swedishVoices(voices);
  const preferred = available.find((voice) => voice.voiceURI === preferredURI);
  if (preferred) return preferred;
  // Voice APIs expose no quality score; these names are only selection hints.
  const score = (voice) => {
    const name = `${voice.name} ${voice.voiceURI}`;
    return (/premium|enhanced|förbättrad|natural|neural/i.test(name) ? 100 : 0)
      + (voice.default ? 10 : 0);
  };
  return [...available].sort((a, b) => score(b) - score(a))[0];
}

export function spokenScheduleText(text) {
  // Avoid reading schedule times as numbers with punctuation ("åtta kolon noll noll").
  return String(text).replace(/\b([01]?\d|2[0-3]):([0-5]\d)\b/g, (_, hour, minute) =>
    minute === "00" ? String(Number(hour)) : `${Number(hour)} ${minute.startsWith("0") ? "noll " : ""}${Number(minute)}`);
}
